import { sv } from '@ucheba/utils/helpers/styles/variables'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  column-gap: 8px;
  z-index: 99;

  button:last-of-type {
    margin-left: auto;
    flex-shrink: 0;
  }
`

export const RelativeContainer = styled.div`
  position: relative;
`

export const FixedContainer = styled(Container)<{ isWhiteBg?: boolean }>`
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: 8px;
  background: ${({ isWhiteBg }) => isWhiteBg && sv.color.white};
`

interface IContainerRiseUp {
  isSticky?: boolean
}

export const ContainerRiseUp = styled(FixedContainer)<IContainerRiseUp>`
  bottom: ${({ isSticky }) => (isSticky ? '8px' : '-56px')};

  left: 8px;

  transition: all 0.2s;
`
